module.exports = __webpack_public_path__ + "static/media/IMG20240128151845.dd6031ce.jpg";